import { Selector } from '../StoreConfig';

export const selectIsMenuOpened: Selector<boolean> = (state) => {
  return state.actionBar.isMenuOpened;
};
